export default __webpack_public_path__ + "eadcb39552862183ca0071531dc50b6b.png";